import {
  PRODUCT_AGGREGATES_REQUEST,
  PRODUCT_AGGREGATES_SUCCESS,
  PRODUCT_AGGREGATES_FAILURE
} from './actions';

import createReducer from 'state/createReducer';

const initialState = {
  request: false,
  errorMessage: null,
  data: {}
}

const handlers = {

  [PRODUCT_AGGREGATES_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null,
      data: state.data
    }
  },

  [PRODUCT_AGGREGATES_SUCCESS](state, payload) {

    return {
      ...state,
      request: false,
      errorMessage: null,
      data: payload.data
    }
  },

  [PRODUCT_AGGREGATES_FAILURE](state, payload) {
    return {
      ...state,
      request: true,
      errorMessage: payload.errorMessage,
      data: {}
    }
  }
}

export default (state = initialState, action) => createReducer(state, action, handlers); 
